import "babel-polyfill";
import "url-search-params-polyfill";
import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import GlobalUtilities from "./GlobalUtilities";
import { VueReCaptcha } from "vue-recaptcha-v3";
// import { registerPrefills } from "./globals/prefills.js";
import { registerDataset } from "@/globals/dataset";

import { createPinia, PiniaVuePlugin } from "pinia";

import * as Sentry from "@sentry/vue";

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

// grab the #app data elements that we need *before* the Vue app is created (the vue dom entry will replace them)
const appElement = document.getElementById("app");

// register a global $dataset that contains data passed in from the underlying index.html
const dataset = registerDataset(appElement);

(async () => {
  // register the global $prefill data - but only allow 'test' prefills if we are not in production
  // this might need to consult the backend API which is why it is async
  // await registerPrefills(!dataset.isProductionLike);

  Vue.config.productionTip = dataset.isProductionLike;
  Vue.mixin(GlobalUtilities);

  const DUMMY_SITE_KEY = "sitekeylocaldev";
  if (!dataset.recaptchaSiteKey) {
    console.log(
      `dataset missing recaptchaSiteKey, defaulting to ${DUMMY_SITE_KEY}`,
    );
  }
  Vue.use(VueReCaptcha, {
    siteKey: dataset.recaptchaSiteKey || DUMMY_SITE_KEY,
  });

  new Vue({
    vuetify,
    el: "#app",
    render: (h) => h(App),
    pinia,
    mounted() {
      /* eslint-disable no-console */
      !this.$dataset.isProductionLike &&
        console.log(
          `Parameters from the underlying index.html are ${JSON.stringify(
            this.$dataset,
          )}`,
        );
      // console.log(
      //  `Values from any prefill parameters are ${JSON.stringify(
      //    this.$prefills
      //  )}`
      // );
      /* eslint-enable no-console */
    },
  });
})();

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_ENVIRONMENT,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: ["localhost", "otrs-test.vcgs.org.au"],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
});
